import React from "react";
import { Env } from "../../../../env";
import styles from "./DoctorLocation.scss";
// import Loading from "../../../utils/loading/Loading";

export const DoctorLocation = ({ lastName, firstName, lat, lng }) => {
  return (
    <div id="GoogleMap" className={styles.locationContainer}>
      <h2 className={styles.locationTitle}>
        Voici l'emplacement du cabinet du docteur {lastName} {firstName}
      </h2>

      {/* <Loading size={80} /> */}
      <iframe
        frameBorder="0"
        // Link top display google map with state lat & state lng
        src={`https://www.google.com/maps/embed/v1/place?q=${lat},${lng}&key=${Env.API_GOOGLE_MAP}`}
      ></iframe>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/InfoDoctor/DoctorLocation/DoctorLocation.jsx